// @ts-nocheck
import { isNonEmptyString } from "@insite/client-framework/Common/Utilities/StringUtilities";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import loadInvoiceByInvoiceNumber from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoiceByInvoiceNumber";
import constants from "@store/constants";
import { submitReturnRequest } from "@store/Framework/Services/ReturnRequestService";
import {
    InvoiceRmaLineDto,
    ReturnRequestResultModel,
    SubmitReturnRequestApiParameter,
} from "@store/Framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        invoiceNumber: string;
        practiceContact: string;
    } & HasOnSuccess<ReturnRequestResultModel> &
        HasOnError<ReturnRequestResultModel>,
    SubmitReturnRequestApiParameter,
    ReturnRequestResultModel
>;

export const PopulateApiParameter: HandlerType = props => {
    const invoiceRmaLines = props.getState().store.pages.returnRequest.invoiceRmaLines[props.parameter.invoiceNumber];
    const invoiceRmaLineKeys = Object.keys(invoiceRmaLines || {});

    const rmaLines: InvoiceRmaLineDto[] = [];

    if (invoiceRmaLines) {
        for (const lineKey of invoiceRmaLineKeys) {
            const rmaLine = invoiceRmaLines[lineKey];

            if (!rmaLine || rmaLine.rmaQtyRequested <= 0) {
                continue;
            }

            rmaLines.push({
                line: rmaLine.line.lineNumber,
                batchNumber: rmaLine.line.properties.batchNumber,
                item: rmaLine.line.properties.item,
                expiryOn: rmaLine.line.properties.expiryOn,
                rmaQtyRequested: rmaLine.rmaQtyRequested,
                rmaReasonCode: rmaLine.rmaReasonCode,
                productNumber: rmaLine.line.productERPNumber,
                rmaLineNumber: rmaLine.line.properties.rmaLineNumber,
                ...(rmaLine.returnReasonComments &&
                isNonEmptyString(rmaLine.returnReasonComments) &&
                rmaLine.rmaReasonCode === constants.rmaReasonCode.incorrectProductReceived
                    ? { returnReasonComments: rmaLine.returnReasonComments }
                    : null),
                ...(rmaLine.fridgeReference && isNonEmptyString(rmaLine.fridgeReference)
                    ? { fridgeReference: rmaLine.fridgeReference }
                    : null),
            } as InvoiceRmaLineDto);
        }
    }

    props.apiParameter = {
        invoiceNumber: props.parameter.invoiceNumber,
        practiceContact: props.parameter.practiceContact,
        rmaLines: rmaLines,
    };
};

export const SendDataToApi: HandlerType = async props => {
    if (props.apiParameter) {
        await submitReturnRequest(props.apiParameter).then(
            success => {
                props.dispatch({
                    type: "Store/Pages/ReturnRequest/CompleteSubmitReturnRequestForm",
                    invoiceNumber: props.parameter.invoiceNumber,
                });

                const reloadInvoiceParameters = {
                    invoiceNumber: props.parameter.invoiceNumber,
                    additionalExpands: ["shipments", "rmadata"],
                };

                props.dispatch(loadInvoiceByInvoiceNumber(reloadInvoiceParameters));
                props.parameter.onSuccess?.(success);
            },
            error => {
                const errorResult: ReturnRequestResultModel = (error && error.errorJson) || {};
                props.parameter.onError?.(errorResult);
            },
        );
    }
};

export const chain = [PopulateApiParameter, SendDataToApi];

const submitReturnRequestForm = createHandlerChainRunner(chain, "SubmitReturnRequestForm");
export default submitReturnRequestForm;
